"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = StripePaymentContainer;
var _react = _interopRequireDefault(require("react"));
var _alert = _interopRequireDefault(require("./alert"));
var _submit = _interopRequireDefault(require("./submit"));
var _StripeCardElement = _interopRequireDefault(require("./StripeCardElement"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("br", null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "warning"
}, "Payment in progress please wait");
function StripePaymentContainer({
  loading,
  submitButtonLabel
}) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StripeCardElement.default, {
    disabled: loading
  }), /*#__PURE__*/_react.default.createElement(_submit.default, {
    "data-test-id": "stripe-submit-button",
    type: "primary",
    loading: loading
  }, submitButtonLabel), loading ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _ref, _ref2) : null);
}